<script setup lang="ts">
import { computed } from "vue";

import IconButton from "@/Components/Extend/TcIconButton.vue";

import useUserStore from "@/Modules/User/Store";

export interface CallHandlerProps {
  isLoading: boolean;
}

const emit = defineEmits<{
  (event: "onHangUp"): void;
  (event: "onHangDown"): void;
}>();

const props = defineProps<CallHandlerProps>();

const userStore = useUserStore();

const hangUpIconSize = computed(() => (props.isLoading ? "lg" : "md"));
</script>

<template>
  <div class="call_handler_patient" :class="{ 'call_handler_patient--loading': props.isLoading }">
    <div class="call_handler_patient__hang_down" @click="emit('onHangDown')">
      <IconButton iconName="HangCall" color="background-alt" size="lg" :isLoading="props.isLoading" />
    </div>

    <div class="call_handler_patient__hang_up" @click="emit('onHangUp')" v-if="userStore.getUserIsPatient">
      <IconButton color="background-alt" iconName="Cam" :size="hangUpIconSize" :isLoading="props.isLoading" />
    </div>
  </div>
</template>

<style lang="scss">
.call_handler_patient {
  justify-content: space-evenly;

  &--loading {
    &__hang_down,
    &__hang_up {
      cursor: default !important;
    }
  }

  &__hang_down,
  &__hang_up {
    cursor: pointer;
    height: 72px;
    width: 72px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__hang_down {
    @include colors.bg(semantic, error);
  }

  &__hang_up {
    @include colors.bg(semantic, success);

    svg {
      height: 19px;
      width: 26px;
    }
  }
}
</style>
